import { render } from "./pos-return.vue?vue&type=template&id=10b6cb87"
import script from "./pos-return.vue?vue&type=script&lang=js"
export * from "./pos-return.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__